import type { GraduationCandidateCounts, GraduationCandidates } from '@dosfilos/application';
import { callable } from '../callable';

export type { GraduationCandidate, GraduationCandidates } from '@dosfilos/application';

// Candidatos a graduación del seminario (`listGraduationCandidates`, flag
// `graduation_audit`). Lo lee el personal académico del seminario.
export const graduationCandidatesApi = {
  list: async (input: { tenantId: string }): Promise<GraduationCandidates> => {
    const fn = callable<typeof input, GraduationCandidates>('listGraduationCandidates');
    return (await fn(input)).data;
  },
  /** «Solo cifras» para el gráfico del panel: sin nombres, ids ni códigos. Los
   *  tramos de la última inscripción usan los filtros del panel. */
  counts: async (input: {
    tenantId: string;
    programId: string | null;
    site: string | null;
  }): Promise<GraduationCandidateCounts> => {
    const fn = callable<typeof input & { mode: 'counts' }, GraduationCandidateCounts>(
      'listGraduationCandidates',
    );
    return (await fn({ ...input, mode: 'counts' })).data;
  },
};
